module.exports = __webpack_public_path__ + "static/img/light_texture.4666be8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/textures/light_texture.png
// module id = 442
// module chunks = 1